import { IEventoResponse } from "interfaces/eventos";
import formCadastroEvento from "./forms";
import { formatCurrency } from "helpers/utils";

const { formField } = formCadastroEvento;

const {
  id,
  dataEvento,
  urlBanner,
  urlImageDestaque,
  titulo,
  slug,
  limiteInscricao,
  horaLargada,
  inicioIncricao,
  horaInicioInsc,
  fimInscricao,
  horaFinalInsc,
  valorServico,
  taxaDescontoBoletoEq,
  taxaInscricao,
  qtdParcelaCartao,
  dataVencBoleto,
  dataVencPix,
  dataVencCartao,
  resumo,
  urlResumo,
  termoResp,
  urlRegulamento,
  regulamento,
  infoRetiradaKit,
  urlVideoDivulgacao,
  exibirDestaque,
  exibirListInscrito,
  exibirMap,
  isentarMorador,
  groupInsc,
  latitude,
  longitude,
  modalidadeId,
  statusId,
  nomeDoLocal,
  organizadorId,
  tipoServicoId,
  urlFacebookDivulgacao,
  urlInstagramDivulgacao,
  urlListaInscrito,
  urlTermoResp,
  cep,
  logradouro,
  numero,
  bairro,
  cidade,
  complemento,
  uf,
} = formField;

const initialValue = {
  [titulo.name]: "",
  [dataEvento.name]: "",
  [slug.name]: "",
  [urlBanner.name]: "",
  [urlImageDestaque.name]: "",
  [limiteInscricao.name]: "",
  [horaLargada.name]: "",
  [inicioIncricao.name]: "",
  [horaInicioInsc.name]: "",
  [fimInscricao.name]: "",
  [horaFinalInsc.name]: "23:59",
  [valorServico.name]: "",
  [taxaDescontoBoletoEq.name]: "10",
  [taxaInscricao.name]: "",
  [qtdParcelaCartao.name]: "1",
  [dataVencBoleto.name]: "",
  [dataVencPix.name]: "",
  [dataVencCartao.name]: "",
  [resumo.name]: "",
  [urlResumo.name]: "",
  [termoResp.name]:
    "<blockquote><strong>Termo de responsabilidade individual ou em equipe:</strong></blockquote><p>Declaro que participo do evento acima por livre e espontânea vontade, isentando assim de qualquer responsabilidade os Organizadores, Colaboradores, Patrocinadores e Realizadores do evento, declaro também ter lido TODO o regulamento e estou de pleno acordo com todos os seus itens, normas e regras, não podendo alegar futuramente não concordar com as mesmas.</p><p>Declaro gozar de boa saúde , estar em boa forma física e ter treinado adequadamente para esta prova.</p><p>Autorizo, por meio desta, o uso de minha imagem para fins legítimos, renunciando o recebimento de qualquer renda que vier a ser auferida com direitos a qualquer meio de transmissão.</p><p>Assumo que todo material e equipamentos necessários para minha participação na prova são exclusivamente de minha responsabilidade, bem como exclusivamente MINHAS todas as despesas de viagem, hospedagem, alimentação, traslados, seguros, assistência médica e quaisquer outras despesas necessárias, ou provenientes da minha participação neste evento; antes, durante ou depois do mesmo.</p><p>Estou ciente que, ao me cadastrar ou inscrever, me incluindo automaticamente no banco de dados do <strong>TNV TEAM SPORTS</strong>, autorizando-o, a enviar-me correspondências eletrônicas ou físicas sobre propagandas, notícias, promoções ou ações comerciais desenvolvidos pelo mesmo e ou por seus parceiros.</p>",
  [urlRegulamento.name]: "",
  [regulamento.name]: "",
  [infoRetiradaKit.name]:
    "Terão direito ao kit os inscritos presentes, não será entregue kits a terceiros",
  [urlVideoDivulgacao.name]: "",
  [exibirDestaque.name]: "0",
  [exibirListInscrito.name]: "",
  [exibirMap.name]: "1",
  [isentarMorador.name]: "0",
  [groupInsc.name]: "",
  [latitude.name]: "",
  [longitude.name]: "",
  [modalidadeId.name]: "",
  [statusId.name]: "",
  [nomeDoLocal.name]: "",
  [organizadorId.name]: "",
  [tipoServicoId.name]: "",
  [urlFacebookDivulgacao.name]: "",
  [urlInstagramDivulgacao.name]: "",
  [urlListaInscrito.name]: "",
  [urlTermoResp.name]: "",
  [cep.name]: "",
  [logradouro.name]: "",
  [numero.name]: "",
  [bairro.name]: "",
  [complemento.name]: "",
  [uf.name]: "",
  [cidade.name]: "",
};

const dateOnly = (value?: string | null) => value?.slice(0, 10) || "";

const valueEdit = async (evento: IEventoResponse) => {
  const endereco = evento.endereco?.[0];

  return {
    [titulo.name]: evento.titulo,
    [dataEvento.name]: dateOnly(evento.dataEvento),
    [urlBanner.name]: evento.urlBanner || "",
    [urlImageDestaque.name]: evento.urlImageDestaque || "",
    [limiteInscricao.name]: evento.limiteInscricao.toFixed(0),
    [horaLargada.name]: evento.horaLargada,
    [inicioIncricao.name]: dateOnly(evento.inicioIncricao),
    [horaInicioInsc.name]: evento.horaInicioInsc,
    [fimInscricao.name]: dateOnly(evento.fimInscricao),
    [horaFinalInsc.name]: evento.horaFinalInsc,
    [valorServico.name]: formatCurrency(evento.valorServico),
    [taxaDescontoBoletoEq.name]: evento.taxaDescontoBoletoEq,
    [taxaInscricao.name]: formatCurrency(evento.taxaInscricao),
    [qtdParcelaCartao.name]: evento.qtdParcelaCartao.toFixed(0),
    [dataVencBoleto.name]: dateOnly(evento.dataVencBoleto),
    [dataVencPix.name]: dateOnly(evento.dataVencPix),
    [dataVencCartao.name]: dateOnly(evento.dataVencCartao),
    [resumo.name]: evento.resumo || "",
    [urlResumo.name]: evento.urlResumo || "",
    [termoResp.name]: evento.termoResp || "",
    [regulamento.name]: evento.regulamento || "",
    [infoRetiradaKit.name]: evento.infoRetiradaKit || "",
    [exibirDestaque.name]: evento.exibirDestaque ? "1" : "0",
    [exibirListInscrito.name]: evento.exibirListInscrito,
    [exibirMap.name]: evento.exibirMap ? "1" : "0",
    [isentarMorador.name]: evento.isentarMorador ? "1" : "0",
    [groupInsc.name]: evento.groupInsc.toString(),
    [latitude.name]: evento.latitude || "",
    [longitude.name]: evento.longitude || "",
    [modalidadeId.name]: String(evento.modalidade.id || ""),
    [statusId.name]: String(evento.status.id),
    [nomeDoLocal.name]: evento.nomeDoLocal,
    [organizadorId.name]: String(evento.organizador.id),
    [tipoServicoId.name]: String(evento.tipoServico.id),
    [urlVideoDivulgacao.name]: evento.urlVideoDivulgacao || "",
    [urlFacebookDivulgacao.name]: evento.urlFacebookDivulgacao || "",
    [urlInstagramDivulgacao.name]: evento.urlInstagramDivulgacao || "",
    [urlRegulamento.name]: evento.urlRegulamento || "",
    [urlTermoResp.name]: evento.urlTermoResp || "",
    [cep.name]: endereco?.cep || "",
    [logradouro.name]: endereco?.endereco || "",
    [numero.name]: endereco?.numero || "",
    [bairro.name]: endereco?.bairro || "",
    [complemento.name]: endereco?.complemento || "",
    [uf.name]: endereco?.uf?.toUpperCase() || "",
    [cidade.name]: endereco?.cidade || "",
  };
};

export { initialValue, valueEdit };
